<template>
  <div id="organite">
  </div>
</template>

<script>
import Velocity from 'velocity-animate'

var mousePosX;
var mousePosY;
var mousePosVersion = 0;
var scene;
var sceneWidth;
var sceneHeight;

function catchMousePosition(evt){
    mousePosX = evt.pageX;
    mousePosY = evt.pageY;
    mousePosVersion += 1;
}
document.onclick = catchMousePosition;

function selectGene(){
    return String(Math.ceil(Math.sqrt(Math.ceil(Math.random()*25))));
}

var organites = [];
var organiteSpeedMultiplier = 1;

function organiteToggleSpeed(){
    organiteSpeedMultiplier = organiteSpeedMultiplier == 1 ? 2 : 1;
}

var organitesInMotion = true;
function toggleAllOrganites(){
    if(organitesInMotion)
        stopAllOrganites();
    else
        startAllOrganites();
}

function startAllOrganites(){
    for(var i=organites.length;i--;){organites[i].start();}
    organitesInMotion = true;
}

function stopAllOrganites(){
    for(var i=organites.length;i--;){organites[i].stop();}
    organitesInMotion = false;
}

function destroyAllOrganites(){
    for(var i=organites.length;i--;){organites[i].destroy();}
    organites = [];
}

var Organite = function(geneA, geneB, geneC, geneD){
    this.geneA = geneA ? geneA : selectGene();
    this.geneB = geneB ? geneB : selectGene();
    this.geneC = geneC ? geneC : selectGene();
    this.geneD = geneD ? geneD : selectGene();

    this.posVersion = 0;
    this.animation = null;

    this.place = function(posX, posY){
        if(!posX) posX = Math.ceil(Math.random()*sceneWidth);
        if(!posY) posY = Math.ceil(Math.random()*sceneHeight);
        var cellBody = document.createElement('div');
        cellBody.style.top = posY + 'px';
        cellBody.style.left = posX + 'px';
        cellBody.setAttribute('class', 'organite geneA_' + this.geneA + ' geneB_' + this.geneB + ' geneC_' + this.geneC);
      
        var cellCore = document.createElement('div');
        cellCore.setAttribute('class', 'core core' + this.geneD);
      
        cellBody.appendChild(cellCore);
      
        this.node = cellBody;
        scene.appendChild(cellBody);

        this.bringOrganiteToLife();
        organites.push(this);
    }
    this.stop = function(){
        this.animation.stop();
    }
    this.destroy = function(){
        this.animation.stop();
        //$(this.node).remove();
    }
    this.start = function(){
        this.animation.play();
    }
    this.bringOrganiteToLife = function(){
        if(this.posVersion < mousePosVersion){
            this.posVersion = mousePosVersion;
            var posX = mousePosX;
            var posY = mousePosY;
        }
        else{
            var posX = Math.ceil(Math.random() * sceneWidth);
            var posY = Math.ceil(Math.random() * sceneHeight);
        }
        var self = this;

        // this.node.style.top = posY + 'px';
        // this.node.style.left = posX + 'px';
      
        Velocity(
            this.node,
            {top:posY,left:posX},
            {
                duration:(10000 + 20000 * Math.random()),
                complete: function(){ self.bringOrganiteToLife() }
             }
        );
    }
}

export default {
  mounted() {
    scene = document.getElementById('organite');
    sceneWidth  = scene.offsetWidth;
    sceneHeight = scene.offsetHeight;
    for (var i=0; i <= 15; i++) {
      (new Organite()).place();
    };
  }
}
</script>

<style>
#organite {
  width: 100vw;
  height: 70vh;
  position: fixed;
  overflow: hidden;
  z-index: -10;
  bottom: 0;
}

.organite {
  width: 40px;
  height: 40px;
  background: #de2128;
  position: absolute;
  z-index: -1 !important;
  border-radius: 230px;
}

.geneA_1 {
  width: 500px;
  height: 500px;
}

.geneA_2 {
  width: 80px;
  height: 80px;
}

.geneA_3 {
  width: 300px;
  height: 300px;
}

.geneA_4 {
  width: 250px;
  height: 250px;
}

.geneA_5 {
  width: 150px;
  height: 150px;
}

.geneB_1 {
  background: #de2128;
}

.geneB_2 {
  background: #de2128;
  border: 8px solid white;
}

.geneB_3 {
  background: #eaeeef;
  border: 4px solid white;
}

.geneB_4 {
  background: #a59ed4;
}

.geneB_5 {
  background: #cac6e6;
}

.geneC_1 {
  opacity: 0.5;
}

.geneC_2 {
  opacity: 0.2;
}

.geneC_3 {
  opacity: 0.4;
}

.geneC_4 {
  opacity: 0.5;
}

.geneC_5 {
  opacity: 0.2;
}

.geneC_1:hover, .geneC_2:hover, .geneC_3:hover, .geneC_4:hover, .geneC_5:hover {
  opacity: 0.8;
}

.core {
  background: #de2128;
  position: absolute;
  z-index: -1 !important;
  border-radius: 230px;
  opacity: 0.3;
}

.core1 {
  width: 100%;
  height: 100%;
  margin: 0%;
}

.core2 {
  width: 40%;
  height: 40%;
  margin: 30%;
  background: #e8898d;
}

.core3 {
  width: 20%;
  height: 20%;
  margin: 40%;
}

.core4 {
  width: 80%;
  height: 80%;
  margin: 10%;
}

.core5 {
  width: 60%;
  height: 60%;
  margin: 20%;
  background: white;
}

</style>
